import { render, staticRenderFns } from "./HealthPlanForm.vue?vue&type=template&id=74d05fba&"
import script from "./HealthPlanForm.vue?vue&type=script&lang=js&"
export * from "./HealthPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./HealthPlanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports